import { useState, type FC, type PropsWithChildren } from "react";

import Hotspot, { type HotspotProps } from "./components/Hotspot/Hotspot";

import * as s from "./Hotspots.module.scss";

type HotspotsProps = PropsWithChildren<{
	name: string;
	hotspots?: HotspotProps[];
	productGallery?: boolean;
}>;

/**
 * Pass image as children and array of hotspots.
 */
const Hotspots: FC<HotspotsProps> = ({
	name,
	hotspots,
	productGallery,
	children,
}) => {
	const [activeIndex, setActiveIndex] = useState<number | null>(null);

	if (!hotspots) return children;

	return (
		<div className={s.container}>
			{children}
			{hotspots.map((hotspot, index) => (
				<Hotspot
					key={`${name}-${index}-${hotspot.label}`}
					name={name}
					id={index.toString()}
					index={index}
					label={hotspot.label}
					title={hotspot.title}
					content={hotspot.content}
					link={hotspot.link}
					image={hotspot.image}
					xPosition={hotspot.xPosition}
					yPosition={hotspot.yPosition}
					xPositionMobile={hotspot.xPositionMobile}
					yPositionMobile={hotspot.yPositionMobile}
					activeIndex={activeIndex}
					setActiveIndex={setActiveIndex}
					productGallery={productGallery}
				/>
			))}
		</div>
	);
};

export default Hotspots;
